
import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import Datetime from 'react-datetime';
import Modal from 'react-responsive-modal';
import { AgGridReact } from '@ag-grid-community/react';
import "@ag-grid-enterprise/all-modules/dist/styles/ag-grid.css";
import "@ag-grid-enterprise/all-modules/dist/styles/ag-theme-balham.css";
import 'react-datetime/css/react-datetime.css';
import XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import redirectURL from '../redirectURL';
// import { useParams } from 'react-router-dom';
import SweetAlert from 'react-bootstrap-sweetalert';
import ExportIcon from "../../assets/icons/export-arrow.svg";
import ImportIcon from "../../assets/icons/import.svg";
import Filter from '../../assets/icons/SEARCH.png'
import CountdownTimer from './runningtime.js';
import { getHyphenYYYYMMDDHHMM, getHyphenYYYYMMDD, getHyphenDDMMYYYY } from '../common/utils';
// import { FaEdit, FaTrash, FaEye, FaTrashAlt, FaArrowRight, FaCheck, FaPen, FaBell, FaRegBell } from 'react-icons/fa';


const unitsOptions = [
    { value: "truck", label: "FTL" },
    { value: "metric_tons", label: "PTL" },
    { value: "kilogram", label: "Courier" },
    { value: "box", label: "FTL/PTL" }]

var moment = require('moment');



const customSelectStyles = {
    option: (provided) => ({
        ...provided,
        fontSize: '14px',
    }),
    singleValue: (provided) => ({
        ...provided,
        fontSize: '14px',
    }),
};


const Freightrateapprovalsummarycomponent = () => {
    // const { event_id } = useParams()
    const [open, setopen] = useState(false)
    const [openchat, setopenchat] = useState(false)
    const [open1, setopen1] = useState(false)
    const [selectedrowfornegotiate, setselectedrowfornegotiate] = useState({})
    const [openforadmin, setopenforadmin] = useState(false)
    const [baseprice, setbaseprice] = useState(0)
    const [selectedindent, setselectedindent] = useState({})
    const [selectedRows, setSelectedRows] = useState([]);
    const [uploadpaymentterms, setuploadpaymentterms] = useState('')
    const [loadshow, setLoadshow] = useState("show-n")
    const [source_list, setsource_list] = useState([])

    const [overlay, setOverlay] = useState("show-n")
    const [isToggled, setIsToggled] = useState(0);  // 0 for off, 1 for on
    const [show, setShow] = useState(false)
    const [selecteddate, setselecteddate] = useState('')
    const [selectedenddate, setselectedenddate] = useState('')
    const [selectedfromdate, setselectedfromdate] = useState('')

    const [hoveredIconId, setHoveredIconId] = useState(null);
    const [hidebidnowbtn, sethidebidnowbtn] = useState(false)
    var [filterToggle, setFilterToggle] = useState(false)
    const [basicType, setBasicType] = useState("")
    const [basicTitle, setBasicTitle] = useState("")
    const [newBidRate, setNewBidRate] = useState('');
    const [newBidQuantity, setNewBidQuantity] = useState('');
    const [activeDateBtn, setactiveDateBtn] = useState('')
    var filterCardStyle1 = { minHeight: "234px" };
    const [showTooltip, setShowTooltip] = useState(false);
    const [hoveredIcon, setHoveredIcon] = useState(null)
    var filterCardStyle2 = { padding: '20px' };
    var mnFilterClass = { marginLeft: "0px", padding: "0px" };
    const [negotiatedetails, setnegotiatedetails] = useState([])
    const [rfqform, setrfqform] = useState({
        total: '',
        awarded: '',
        drafts: '',
        pending: 'activet1',
        cancelled: '',
        myactivity: '',
        archieved: '',
        upcoming: '',
        selectedindentid: '',
        completed: '',
        current_bidding: 'activet',
        bidding_history: '' // Optionally, clear other tabs

    })
    const [countersfortab, setcountersfortab] = useState({
        pendingcount: 0,
        totalcount: 0,
        approvedcount: 0
    })
    const [indentdetails, setindentdetails] = useState({
        indent_id: '',
        bid_start_date: '',
        end_date: '',
        source: '',
        destination: '', distance: '',
        truck_type: '',
        material: '',
        quantity: 0,
        base_price: 0,
        quote: 0
    })
    const [biddetails, setbiddetails] = useState([])
    const [allindents, setallindents] = useState([])
    const [alldata, setalldata] = useState([])
    const [checkfortext, setcheckfortext] = useState(false)
    const [originaldata, setoriginaldata] = useState([])
    const [bulkUploadModal, setBulkUploadModal] = useState({
        overly: "show-n",
        bulkPrioritySlide: ""
    })
    const [modalloadData, setmodalloadData] = useState([])
    const [filterdata, setfiltereddata] = useState([])
    const [originalindents, setoriginalindents] = useState([])
    const [rankingdetails, setrankingdetails] = useState([])
    const [selected_bid_price, setselected_bid_price] = useState('')
    const [negotiate_value, setnegotiate_value] = useState('')

    const [selected_bid_quantity, setselected_bid_quantity] = useState('')
    const [transit_time, settransit_time] = useState('')

    const [bidsdata, setbidsdata] = useState([])
    const [rankedBids, setRankedBids] = useState([]);
    const [searchfilter, setsearchfilter] = useState({
        selected_source: "All",
        // other filters
    });

    const [isCardOpen, setIscardOpen] = useState("")
    const [isCardOpen1, setIscardOpen1] = useState("")
    const [isCardOpen2, setIscardOpen2] = useState("")
    const [isCardOpen3, setisCardOpen3] = useState('')
    const [indent_for_approve, setindent_for_approve] = useState([]);

    const [indent_for_approve_for_bid, setindent_for_approve_for_bid] = useState([]);

    const [indent_for_approve1, setindent_for_approve1] = useState([]);
    const [rowSelection, setrowSelection] = useState('multiple')
    const [selecteddata, setselecteddata] = useState({})
    const [showAllRecords, setShowAllRecords] = useState(false);

    const [bidHistory, setBidHistory] = useState([])
    const [inputTextValue, setInputTextValue] = useState("")
    const [inputTextQuantity, setInputTextQuantity] = useState("")
    const [negotiations, setNegotiations] = useState([])
    const [negotiationsHistory, setNegotiationsHistory] = useState([])
    const [isProposedInputOpen, setIsProposedInputOpen] = useState("")
    const [isVendorInputOpen, setIsVendorInputOpen] = useState("")
    const [additionalComments, setAdditionalComments] = useState("")
    const [modelForAdditionalComments, setModelForAdditionalComments] = useState(false)
    const [vendorQuotes, setVendorQoutes] = useState([])
    const [modelForShowBids, setModelForShowBids] = useState(false)
    const [modelForNotifications, setModelForNotifications] = useState(false)
    const [notificationUnread, setNotificationUnread] = useState([])
    const [notificationRead, setNotificationRead] = useState([])
    const [modelForEditAssigned, setModelForEditAssigned] = useState(false)
    const [rejectedVendorBid, setRejectedVendorBid] = useState("")
    const [rejectedVendorIndent, setRejectedVendorIndent] = useState("")
    const [rejectionReason, setRejectionReason] = useState("")

    const [timeLeft, setTimeLeft] = useState(null);
    const [text, setText] = useState('');
    var [destinationdetails, setdestinationdetails] = useState([])

    const getbidhistory = async (indent_id) => {
        console.log(indent_id)
        await redirectURL.post("/consignments/getBidHistory", { indent_id }).then(response => {
            setBidHistory(response.data.bid_history)
            setNegotiations(response.data.negotiations)
            setNegotiationsHistory(response.data.negotiationslogs)
        })
    }
    useEffect(() => {
        redirectURL.post('/consignments/getsourcemaster').then((resp) => {
            let data = resp.data;
            let source_list = [];

            data.forEach((e) => {
                if (e.source_name != '' && e.source_name != undefined) {
                    source_list.push({ value: e.source_name, label: e.source_name });
                }
            });

            setsource_list(source_list);
            const today = new Date();
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);

            const formatDate = (date) => {
                const day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
                const month = (date.getMonth() + 1) < 10 ? "0" + (date.getMonth() + 1) : (date.getMonth() + 1);
                const year = date.getFullYear();
                return `${day}-${month}-${year}`; // DD-MM-YYYY
            }

            setselectedfromdate(formatDate(yesterday));
            setselectedenddate(formatDate(today));
            fetchData(yesterday, today);
        })
    }, []);


    const fetchData = (from_date, to_date, source) => {
        setLoadshow('show-m')
        setOverlay('show-m')
        var params = {
            user_type: localStorage.getItem("user_type"),
            email: localStorage.getItem("email"),
            from_date: getHyphenYYYYMMDD(from_date),
            to_date: getHyphenYYYYMMDD(to_date)
        }

        if (source && source !== "All") {
            params.source = source;
        }

        redirectURL.post("/consignments/fetchRFQdataforsourcewise", params).then(response => {
            let data = response.data;
            console.log(data, '215')
            setoriginaldata(data)


            // data = data.filter((e) => {
            //     const assignedDateStr = getHyphenYYYYMMDD(e.create_date); // "YYYY-MM-DD"
            //     const fromStr = getHyphenYYYYMMDD(from_date);
            //     const toStr = getHyphenYYYYMMDD(to_date);


            //     return assignedDateStr >= fromStr && assignedDateStr <= toStr;
            // });

            let processedData = data
            // .map(row => ({
            //     ...row,
            //     // status: row.freightdataapproved === 1 ? 'Approved' : 'Pending'
            // }));

            setalldata(processedData)
            if (rfqform.total == 'activet1') {
                processedData = processedData
            }
            else if (rfqform.pending == 'activet1') {
                processedData = processedData.filter(e => e.freightdataapproved != 1)
            }
            else if (rfqform.awarded == 'activet1') {
                processedData = processedData.filter(e => e.freightdataapproved == 1)
            }

            const sourcedata = segregateBySource(processedData);

            console.log("Sourced Data:251", sourcedata);
            setallindents(sourcedata);
            setcheckfortext(data.length === 0);

            setoriginalindents(sourcedata);
            setcheckfortext(sourcedata.length === 0);

            setLoadshow('show-n')
            setOverlay('show-n')
        })
    }
    const handleCheckboxChange = (e, row) => {
        if (e.target.checked) {
            // Add row to selectedRows
            setSelectedRows((prev) => [...prev, row]);
        } else {
            // Remove row from selectedRows
            setSelectedRows((prev) => prev.filter((r) => r.indent_id !== row.indent_id));
        }
    };

    const segregateBySource = (array) => {
        const result = {};

        array.forEach(item => {
            const source = item.source;

            // If the source key doesn't exist, initialize it with an empty array
            if (!result[source]) {
                result[source] = [];
            }

            // Push the current item into the corresponding source group
            result[source].push(item);
        });

        return result;
    };
    const onClickHideall = () => {
        setLoadshow('show-m')
        setOverlay('show-n')

    }
    const onShowdealerdata = (indent_id) => {
        console.log(indent_id, 'indent_id')
        setisCardOpen3(true)
        var params = {
            indent_id: indent_id
        }
        redirectURL.post('/consignments/getstroreddata', params).then((resp) => {
            var data1 = resp.data
            var destinations = []
            data1.map((e) => {
                destinations.push({
                    "indent_id": indent_id,
                    "dealer_city": e.dealer_city,
                    'dealer_pincode': e.dealer_pincode,
                    "bid_price": e.bid_price,
                    "transit_days": e.transit_days
                })
            })
            setindent_for_approve1(destinations)

        })

    }
    const onClickAcceptNegotiation = (indent_id, bid_price, no_of_deliveries, vendor_email_id, indent_created_by) => {
        if (localStorage.getItem('roles') == 'TRANSPORTER') {
            setIscardOpen1(true)
            var data = originalindents.filter(e => e.indent_id == indent_id)
            console.log(data, '371')
            console.log(data[0].destination, 'data[0].destination')
            var destinations = []
            var data1 = data[0].destination
            data1 = JSON.parse(data1);

            data1.map((e) => {
                destinations.push({
                    "indent_id": indent_id,
                    "dealer_city": e.dealer_city,
                    'dealer_pincode': e.dealer_pincode
                })
            })
            setindent_for_approve(destinations)
            setselecteddata({
                indent_id: indent_id,
                bid_price: bid_price,
                no_of_deliveries: no_of_deliveries,
                vendor_email_id: vendor_email_id,
                indent_created_by: indent_created_by
            });
        }
        else if (localStorage.getItem('roles') == 'AL_ADMIN') {
            const params = {
                indent_id,
                bid_price,
                no_of_deliveries,
                vendor_email_id,
                email: localStorage.getItem("email"),
                user_type: localStorage.getItem("user_type"),
                indent_created_by
            };

            redirectURL.post("/consignments/acceptNegotiationValue", params).then(response => {
                const isSuccess = response.data.status === "success";
                setShow(true);
                setBasicType(isSuccess ? "success" : "danger");
                setBasicTitle(response.data.message);

                if (isSuccess) {
                    setIsVendorInputOpen("");
                    setIsProposedInputOpen("");
                    // socket.current.emit('bidUpdate', []);
                }
            }).catch(error => {
                console.log(error)
                setShow(true);
                setBasicType("danger");
                setBasicTitle("An error occurred while processing the request.");
            });
        }
    };
    const onShowdata = (indent_id) => {
        setIscardOpen2(true)
        var params = {
            indent_id: indent_id
        }
        redirectURL.post('/consignments/getstroreddata', params).then((resp) => {
            var data1 = resp.data
            var destinations = []
            data1.map((e) => {
                destinations.push({
                    "indent_id": indent_id,
                    "dealer_city": e.dealer_city,
                    'dealer_pincode': e.dealer_pincode,
                    "bid_price": e.bid_price,
                    "transit_days": e.transit_days
                })
            })
            setindent_for_approve1(destinations)

        })

    }

    const onClickAcceptQuotation = (indent_id, bid_price, no_of_deliveries, vendor_email_id, indent_created_by) => {
        const params = {
            indent_id,
            bid_price,
            no_of_deliveries,
            vendor_email_id,
            email: localStorage.getItem("email"),
            user_type: localStorage.getItem("user_type"),
            indent_created_by
        };
        console.log(params, 'params')
        redirectURL.post("/consignments/AcceptQuotation", params).then(response => {
            const isSuccess = response.data.status === "success";
            setShow(true);
            setBasicType(isSuccess ? "success" : "danger");
            setBasicTitle(response.data.message);

            if (isSuccess) {
                setIsVendorInputOpen("");
                setIsProposedInputOpen("");
                setIscardOpen1(false)
                //  socket.current.emit('bidUpdate', []);
            }
        })
            .catch(error => {
                console.log(error)
                setShow(true);
                setBasicType("danger");
                setBasicTitle("An error occurred while processing the request.");
            });
    };
    const onCloseModal = () => {
        setModelForAdditionalComments(false)
        setModelForShowBids(false)
        setModelForNotifications(false)
        setModelForEditAssigned(false)
        setIscardOpen1(false)
        setIscardOpen2(false)
        setisCardOpen3(false)
    };
    const fetchNotificationsData = (indent_id) => {
        var params = {
            email: localStorage.getItem("email"),
            indent_id: indent_id
        }
        redirectURL.post("/consignments/fetchNotificationsData", params).then(response => {
            setNotificationUnread(response.data.Unreadnotifications)
            setNotificationRead(response.data.Readnotifications)
            setModelForNotifications(true)
            const indent = allindents.find(e => e.indent_id === indent_id);
            if (indent) {
                indent.notification_count = 0;
            }
        })
    }


    const modalStyles = {
        width: '500px !important',
    }
    const modalStyles1 = {
        width: '300px !important',
    }
    const columnwithdefs = [
        {
            headerName: "Rank",
            field: "truck_no",
            width: 200,
            resizable: true,
        },
        {
            headerName: "Bid Price",
            field: "truck_no",
            width: 100,
            resizable: true,
        },
        {
            headerName: "Bid Quantity",
            field: "truck_no",
            width: 100,
            resizable: true,
        },
    ]

    const handleSelectChange = (name, selectedOption) => {
        setsearchfilter((prev) => ({
            ...prev,
            [name]: selectedOption ? selectedOption.value : "All",
        }));
    };



    const getindents = (e) => {
        e.preventDefault();
        let data = []
        if (rfqform.active === 'activet') {
            data = originalindents.filter(e => e.indent_expired != 1)
        }
        else if (rfqform.cancelled === 'activet') {
            data = originalindents.filter(e => e.indent_expired == 1)
        }

    };
    const handleInputChangeforbid = (index, field, value) => {
        const updatedDestinations = [...indent_for_approve_for_bid];
        updatedDestinations[index][field] = value; // Update the specific field
        setindent_for_approve_for_bid(updatedDestinations); // Update state
    };
    const handleInputChangeforaccept = (index, field, value) => {
        const updatedDestinations = [...indent_for_approve];
        updatedDestinations[index][field] = value; // Update the specific field
        setindent_for_approve(updatedDestinations); // Update state
    };
    const handleInputChangeforaccept1 = (index, field, value) => {
        const updatedDestinations = [...indent_for_approve1];
        updatedDestinations[index][field] = value; // Update the specific field
        setindent_for_approve1(updatedDestinations); // Update state
    };

    const onSubmitdata = (e) => {
        const hasInvalidFields = indent_for_approve.some(
            (destination) =>
                !destination.bid_price || !destination.transit_days
        );

        if (hasInvalidFields) {
            alert("Please fill in all Bid Price and Transit Days fields before submitting.");
            return;
        }
        const submissionData = indent_for_approve.map((destination) => ({
            indent_id: destination.indent_id,
            dealer_city: destination.dealer_city,
            dealer_pincode: destination.dealer_pincode,
            bid_price: destination.bid_price,
            transit_days: destination.transit_days,
        }));
        var params1 = {
            submissionData: submissionData
        }
        redirectURL.post('/consignments/storedata', params1).then((resp) => {

        })
        var { indent_id, bid_price, no_of_deliveries, vendor_email_id, indent_created_by } = selecteddata
        const params = {
            indent_id,
            bid_price,
            no_of_deliveries,
            vendor_email_id,
            email: localStorage.getItem("email"),
            user_type: localStorage.getItem("user_type"),
            indent_created_by
        };

        redirectURL.post("/consignments/acceptNegotiationValue", params).then(response => {
            const isSuccess = response.data.status === "success";
            setShow(true);
            setBasicType(isSuccess ? "success" : "danger");
            setBasicTitle(response.data.message);
            setIscardOpen1(false)

            if (isSuccess) {
                setIsVendorInputOpen("");
                setIsProposedInputOpen("");
                // socket.current.emit('bidUpdate', []);
            }
        }).catch(error => {
            console.log(error)
            setShow(true);
            setBasicType("danger");
            setBasicTitle("An error occurred while processing the request.");
        });



    }
    const onSubmitdata1 = (e) => {
        const hasInvalidFields = indent_for_approve.some(
            (destination) =>
                !destination.bid_price || !destination.lr_no
        );

        if (hasInvalidFields) {
            alert("Please fill LR No field before submitting");
            return;
        }
        const submissionData = indent_for_approve1.map((destination) => ({
            indent_id: destination.indent_id,
            dealer_city: destination.dealer_city,
            dealer_pincode: destination.dealer_pincode,
            bid_price: destination.bid_price,
            transit_days: destination.transit_days,
            lr_no: destination.lr_no
        }));
        console.log("Prepared submission data:", submissionData);
        var params1 = {
            submissionData: submissionData
        }
        redirectURL.post('/consignments/storelrno', params1).then((resp) => {
            if (resp.data == 'success') {
                setShow(true);
                setBasicType("success");
                setBasicTitle('Successfully Submitted');
                setIscardOpen2(false)
            }

        })
            .catch(error => {
                console.log(error)
                setShow(true);
                setBasicType("danger");
                setBasicTitle("An error occurred while processing the request.");
            });


    }

    const handleInputChange = (e) => {
        setselected_bid_quantity(e)
        // setNewBidQuantity(e)
    };
    const handlertransittime = (e) => {
        settransit_time(e)
    }
    const handleInputChange1 = (e) => {
        setselected_bid_price(e)
        // setNewBidRate(e)
    };
    const handleInputChange2 = (e) => {
        setnegotiate_value(e)
    };
    const getcountersforindents = (data) => {
        var indentsdata = data;
        // Total Data (directly entire data)
        var totaldata = indentsdata;

        // Awarded data (freightdataapproved == 1)
        var awardeddata = indentsdata.filter(e => e.freightdataapproved == 1);

        // Pending data (freightdataapproved != 1)
        var pendingdata = indentsdata.filter(e => e.freightdataapproved != 1);

        // Draft data (comes separately)

        // Finally set all counters
        setcountersfortab({
            totalcount: totaldata.length,
            awardcount: awardeddata.length,
            pendingcount: pendingdata.length,
        });
    }

    const onSubmitquote = (e) => {
        e.preventDefault()
        console.log(indent_for_approve_for_bid, 'biddetails')
        var selected_bid_price = 0
        var selected_bid_quantity = selectedindent.destination
        selected_bid_quantity = JSON.parse(selected_bid_quantity)
        console.log(selected_bid_quantity.length, 'selected_bid_quantityselected_bid_quantity')
        var transit_time = 0
        indent_for_approve_for_bid.forEach(item => {
            selected_bid_price += parseFloat(item.bid_price); // Sum the bid prices
            transit_time += parseInt(item.transit_days); // Sum the transit days
        });

        var params = {
            bid_price: selected_bid_price,
            no_of_deliveries: selected_bid_quantity.length,
            email: localStorage.getItem('email'),
            indent_id: selectedindent.indent_id,
            username: localStorage.getItem('user_name'),
            transit_time: transit_time
        }
        redirectURL.post('consignments/submitQuote', params).then((response) => {
            if (response.data.status == 'success') {
                setIscardOpen("")
                setShow(true)
                setBasicType("success")
                setBasicTitle('Your Bid has been successfully placed')
                setselected_bid_price("")
                setselected_bid_quantity("")
                // if (response.data.status == "success") socket.current.emit('bidUpdate', []);
                // setopen(false)
                // fetchgetindents()
            }
        })


    }
    const selectfilters = () => {
        console.log(selectedfromdate, selectedenddate)
        const from_date = selectedfromdate
        const to_date = selectedenddate
        const parseDate = (dateStr) => {
            const parts = dateStr.split('-'); // [DD, MM, YYYY]
            return new Date(parts[2], parts[1] - 1, parts[0]);
        }

        const fromDateObj = parseDate(from_date);
        const toDateObj = parseDate(to_date);

        if (fromDateObj > toDateObj) {
            setShow(true);
            setBasicType("danger");
            setBasicTitle('From Date should be Less than To Date');
            setLoadshow('show-n');
            setOverlay('show-n');
            return;
        }

        fetchData(fromDateObj, toDateObj, searchfilter.selected_source);


        // // Filter by date
        // let data = originaldata.filter((e) => {
        //     const assignedDateStr = getHyphenYYYYMMDD(e.create_date); // "YYYY-MM-DD"
        //     const fromStr = getHyphenYYYYMMDD(fromDateObj);
        //     const toStr = getHyphenYYYYMMDD(toDateObj);


        //     return assignedDateStr >= fromStr && assignedDateStr <= toStr;
        // });

        // console.log(data, '732')
        // // Filter by selected source, if any


        // var totaldata = data
        // if (rfqform.total == 'activet1') {
        //     totaldata = totaldata
        // }
        // else if (rfqform.pending == 'activet1') {
        //     totaldata = totaldata.filter(e => e.freightdataapproved != 1)
        // }
        // else if (rfqform.awarded == 'activet1') {
        //     totaldata = totaldata.filter(e => e.freightdataapproved == 1)
        // }

        // // if (searchfilter.selected_source) {
        // //   data = data.filter(e => e.source === searchfilter.selected_source);
        // // }
        // setalldata(data)
        // const sourcedata = segregateBySource(totaldata);

        // if (data.length === 0) {
        //     setcheckfortext(true);
        // } else {
        //     setcheckfortext(false);
        // }

        // setallindents(sourcedata);
        // setLoadshow('show-n');
        // setOverlay('show-n');
    };




    // const exportToExcel = () => {
    //     const excelData = [];
    //     if(allindents.length>0){

    //     }
    //     Object.keys(allindents).forEach((source) => {
    //         if (!Array.isArray(allindents[source])) return;

    //         allindents[source].forEach((e, index) => {
    //             const rankedVendors = [...(e.vendorsquotedata || [])]
    //                 .filter(v => v.quoted_value)
    //                 .sort((a, b) => a.quoted_value - b.quoted_value);

    //             const top5Vendors = rankedVendors.slice(0, 5);
    //             const l10Vendor = rankedVendors.length >= 10 ? rankedVendors[9] : rankedVendors[rankedVendors.length - 1];
    //             const lowestVendor = rankedVendors[0];

    //             // Parse materials
    //             let materialType = "N/A";
    //             try {
    //                 const destination = JSON.parse(e.destination);
    //                 const filteredDestinations = destination.filter(dest => dest.dealer_pincode === e.dealer_pincode);
    //                 const materialTypes = filteredDestinations.flatMap(dest =>
    //                     (dest.materials || []).map(material => material.material_type)
    //                 );
    //                 materialType = materialTypes.length > 0 ? materialTypes.join(", ") : "N/A";
    //             } catch (error) {
    //                 materialType = "N/A";
    //             }

    //             excelData.push({
    //                 "Source": source,
    //                 "S.No": index + 1,
    //                 "Indent ID": e.indent_id || "N/A",
    //                 "GR No": e.lr_no || "N/A",
    //                 "Date": getHyphenYYYYMMDD(e.indent_assigned_date) || "N/A",
    //                 "create_date": getHyphenYYYYMMDD(e.create_date) || "N/A",
    //                 "From": e.source || "N/A",
    //                 "Destination": e.dealer_city || "N/A",
    //                 "Vehicle Type": e.type_of_truck || "N/A",
    //                 "Material": materialType,
    //                 "Freight Bifurcation": e.freight_bifurcation || "N/A",
    //                 "L1": top5Vendors[0] ? `${top5Vendors[0].vendor_name} - ₹${top5Vendors[0].quoted_value}` : "N/A",
    //                 "L2": top5Vendors[1] ? `${top5Vendors[1].vendor_name} - ₹${top5Vendors[1].quoted_value}` : "N/A",
    //                 "L3": top5Vendors[2] ? `${top5Vendors[2].vendor_name} - ₹${top5Vendors[2].quoted_value}` : "N/A",
    //                 "L4": top5Vendors[3] ? `${top5Vendors[3].vendor_name} - ₹${top5Vendors[3].quoted_value}` : "N/A",
    //                 "L5": top5Vendors[4] ? `${top5Vendors[4].vendor_name} - ₹${top5Vendors[4].quoted_value}` : "N/A",
    //                 "Highest Bid": l10Vendor ? `${l10Vendor.vendor_name} - ₹${l10Vendor.quoted_value}` : "N/A",
    //                 "Tentative Savings": l10Vendor && lowestVendor
    //                     ? l10Vendor.quoted_value - lowestVendor.quoted_value
    //                     : "0"
    //             });
    //         });
    //     });

    //     // Generate Excel Sheet
    //     const worksheet = XLSX.utils.json_to_sheet(excelData);
    //     const workbook = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(workbook, worksheet, "Indents");

    //     const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    //     const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    //     saveAs(data, `Indents_Export_${new Date().toISOString().slice(0,10)}.xlsx`);

    // };
    const extractDestinationAndMaterial1 = (destinationStr) => {
        let dealerCity = '';
        let materialTypes = '';
        try {
            const destination = JSON.parse(destinationStr || "[]");
            if (Array.isArray(destination) && destination.length > 0) {
                dealerCity = destination
                    .map(dest => dest.dealer_city)
                    .filter(city => city)
                    .join(', ');

                materialTypes = destination
                    .flatMap(dest => dest.materials || [])
                    .map(m => m.material_type)
                    .filter(m => m)
                    .join(', ');
            }
        } catch (err) {
            console.error("Error parsing destination:", err);
        }
        return { dealerCity, materialTypes };
    };

    const exportToExcel = () => {
        const excelData = [];
        if (Object.keys(allindents).length === 0) return;

        Object.keys(allindents).forEach((source) => {
            if (!Array.isArray(allindents[source])) return;

            allindents[source].forEach((e, index) => {
                const rankedVendors = [...(e.vendorsquotedata || [])]
                    .filter(v => v.quoted_value)
                    .sort((a, b) => a.quoted_value - b.quoted_value);

                const top5Vendors = rankedVendors.slice(0, 5);
                const l10Vendor = rankedVendors.length >= 10 ? rankedVendors[9] : rankedVendors.at(-1);
                const lowestVendor = rankedVendors[0];

                // Use the common utility function
                const { dealerCity, materialTypes } = extractDestinationAndMaterial1(e.destination);

                excelData.push({
                    "Source": source,
                    "S.No": index + 1,
                    "Indent ID": e.indent_id || "N/A",
                    "GR No": e.lr_no || "N/A",
                    "Date": getHyphenYYYYMMDD(e.indent_assigned_date) || "N/A",
                    "create_date": getHyphenYYYYMMDD(e.create_date) || "N/A",
                    "From": e.source || "N/A",
                    "Destination": dealerCity || "N/A",
                    "Vehicle Type": (e.type_of_truck === 'others' ? e.selected_truck_type : e.type_of_truck) || "N/A",
                    "Material": materialTypes || "N/A",
                    "Freight Bifurcation": e.freight_bifurcation || "N/A",
                    "L1": top5Vendors[0] ? `${top5Vendors[0].vendor_name} - ₹${top5Vendors[0].quoted_value}` : "N/A",
                    "L2": top5Vendors[1] ? `${top5Vendors[1].vendor_name} - ₹${top5Vendors[1].quoted_value}` : "N/A",
                    "L3": top5Vendors[2] ? `${top5Vendors[2].vendor_name} - ₹${top5Vendors[2].quoted_value}` : "N/A",
                    "L4": top5Vendors[3] ? `${top5Vendors[3].vendor_name} - ₹${top5Vendors[3].quoted_value}` : "N/A",
                    "L5": top5Vendors[4] ? `${top5Vendors[4].vendor_name} - ₹${top5Vendors[4].quoted_value}` : "N/A",
                    "Highest Bid": l10Vendor ? `${l10Vendor.vendor_name} - ₹${l10Vendor.quoted_value}` : "N/A",
                    "Tentative Savings": l10Vendor && lowestVendor
                        ? l10Vendor.quoted_value - lowestVendor.quoted_value
                        : "0"
                });
            });
        });

        // Generate Excel Sheet
        const worksheet = XLSX.utils.json_to_sheet(excelData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Indents");

        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: "application/octet-stream" });
        saveAs(data, `Indents_Export_${new Date().toISOString().slice(0, 10)}.xlsx`);
    };


    const handlerStartDateTime = (event, currentDate, selectedDate) => {
        var d = new Date(event._d);

        var startdate =
            (d.getDate() < 10 ? "0" + d.getDate() : d.getDate()) + "-" +
            ((d.getMonth() + 1) < 10 ? "0" + (d.getMonth() + 1) : (d.getMonth() + 1)) + "-" +
            d.getFullYear();

        setselectedfromdate(startdate);
    }

    const handlerEndDateTime = (event, currentDate, selectedDate) => {
        var d = new Date(event._d);

        var enddate =
            (d.getDate() < 10 ? "0" + d.getDate() : d.getDate()) + "-" +
            ((d.getMonth() + 1) < 10 ? "0" + (d.getMonth() + 1) : (d.getMonth() + 1)) + "-" +
            d.getFullYear();

        setselectedenddate(enddate);
    }


    const closeAlert = () => {
        setShow(false)
        setopen(false)
    }

    const onIconHover = (rowId) => {
        setHoveredIconId(rowId); // Set the hovered icon ID to the specific row ID
    };
    const onClickparentTab = (e) => {
        var current_date = new Date()
        let data = []
        console.log(alldata, 'alldata')
        console.log(e, '792')
        if (e === 'total') {
            setrfqform((prevForm) => ({
                ...prevForm,
                awarded: '',
                total: 'activet1',
                pending: ''
            }));
            data = alldata
            const sourcedata = segregateBySource(data);


            setallindents(sourcedata);
            setcheckfortext(data.length === 0);

            setoriginalindents(sourcedata);
        }
        else if (e === 'awarded') {
            setrfqform((prevForm) => ({
                ...prevForm,
                awarded: 'activet1',
                total: '',
                pending: ''
            }));
            console.log(alldata, 'alldata')
            data = alldata.filter(e => e.freightdataapproved == 1)
            const sourcedata = segregateBySource(data);


            setallindents(sourcedata);
            setcheckfortext(data.length === 0);

            setoriginalindents(sourcedata);
        }

        else if (e === 'pending') {
            setrfqform((prevForm) => ({
                ...prevForm,
                awarded: '',
                total: '',
                pending: 'activet1' // Optionally, clear other tabs
            }));
            data = alldata.filter(e => e.freightdataapproved != 1)
            console.log(data, 'data')
            const sourcedata = segregateBySource(data);


            setallindents(sourcedata);
            setcheckfortext(data.length === 0);

            setoriginalindents(sourcedata);
        }

    };
    const onclickapprovedata = () => {

        if (!selectedRows || selectedRows.length === 0) {
            return;
        }

        const selected_indents = selectedRows.map(e => e.indent_id);

        const approvalParams = {
            selected_indents: selected_indents
        };

        redirectURL.post('/consignments/approvedfrightdata', approvalParams)
            .then((resp) => {
                setShow(true);
                setBasicType("success");
                setBasicTitle('Successfully Approved');

                setLoadshow('show-m');
                setOverlay('show-m');
                setSelectedRows([]);
                selectfilters();

                // const fetchParams = {
                //     user_type: localStorage.getItem("user_type"),
                //     email: localStorage.getItem("email")
                // };

                // redirectURL.post("/consignments/fetchRFQdataforsourcewise", fetchParams)
                //     .then(response => {
                //         const data = response.data;
                //         setLoadshow('show-m');
                //         setOverlay('show-m');
                //         let data1 = data.filter(e => {
                //             const assignedDateStr = getHyphenYYYYMMDD(e.create_date);
                //             const create_date = new Date(assignedDateStr);
                //             return create_date >= from_date && create_date <= to_date;
                //         });
                //         let processedData = data1.map(row => ({
                //             ...row,
                //             // status: row.freightdataapproved === 1 ? 'Approved' : 'Pending for Approval'
                //         }));
                //         const sourcedata = segregateBySource(processedData);
                //         setalldata(processedData)
                //         setallindents(sourcedata);
                //         setLoadshow('show-n');
                //         setOverlay('show-n');
                //     })
                //     .catch(err => {
                //         setLoadshow('show-n');
                //         setOverlay('show-n');
                //     });
            })
            .catch(err => {
                console.error("Error approving freight data:", err);
            });
    };

    const onClickViewPOD = (e) => {
        // console.log("documnent_view", e)

        let params = {
            pod_document: e,
        }
        // console.log("params",params)
        redirectURL.post("/billing/downloadfileforroad", params, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': localStorage.getItem("userid")
            }
        }).then(res => {
            const downloadUrl = decodeURIComponent(res.data.url);
            const link = document.createElement("a");
            link.href = downloadUrl;
            link.setAttribute("download", e || ""); // Optional: specify download filename
            link.setAttribute("target", "_blank");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

        }).catch(function (error) {
            // console.log(error);
        })
    }
    const columnDef = []
    const toggleShowAllRecords = () => {
        setShowAllRecords((prev) => !prev);
    };
    const defaultColDef = {
        resizable: true,
        sortable: true,
        filter: true,
        headerClass: 'ag-header-bold' // 👈 add this
    };

    const sourceOptions = [
        { label: "All", value: "All" },
        { label: 'Hosur', value: 'Hosur' },
        { label: 'Indore', value: 'Indore' },
        { label: 'Alwar', value: 'Alwar' },
        { label: 'Pantnagar', value: 'Pantnagar' },
        { label: 'Ennore', value: 'Ennore' },
        { label: 'Bhandara', value: 'Bhandara' },
        { label: 'Jamshedpur', value: 'Jamshedpur' },
        { label: 'Chennai', value: 'Chennai' },
        { label: 'Roorkee', value: 'Roorkee' },
        { label: 'Jalandhar', value: 'Jalandhar' },
        // { label: 'Coimbatore', value: 'Coimbatore' },
        // ...Object.keys(originalindents).map((key) => ({
        //   label: key,
        //   value: key,
        // })),
    ];

    return (
        <div className="container-fluid">
            <SweetAlert
                show={show}
                type={basicType}
                title={basicTitle}
                confirmBtnCssClass={`btn btn-${basicType}`}
                onConfirm={closeAlert}
            >
            </SweetAlert>
            <div className="row d-flex align-items-center justify-content-between">
                <h5 className="col-sm-6 fbold f20">
                    <span>Freight Rate Approval Summary</span>
                </h5>

            </div>
            <div className="row mt-7p">
                <div className="form-group col-12 d-flex justify-content-between align-items-center">

                    {/* Left Side */}
                    <div className="d-flex align-items-end flex-wrap">
                        <div className="mr-2">
                            <label>From Date</label>
                            <Datetime
                                value={selectedfromdate}
                                disableCloseOnClickOutside={false}
                                closeOnSelect={true}
                                inputProps={{ placeholder: 'Select From Date', name: 'startDate', autoComplete: 'off', readOnly: true, style: { height: "36px", borderRadius: '4px' } }}
                                dateFormat="DD-MM-YYYY"
                                timeFormat={false}
                                onChange={handlerStartDateTime}
                            />
                        </div>

                        <div className="mr-2">
                            <label>To Date</label>
                            <Datetime
                                value={selectedenddate}
                                disableCloseOnClickOutside={false}
                                closeOnSelect={true}
                                inputProps={{
                                    placeholder: 'Select To Date',
                                    name: 'enddate',
                                    autoComplete: 'off',
                                    readOnly: true,
                                    style: { height: "36px", borderRadius: '4px' }   // 👈 increased height
                                }}
                                dateFormat="DD-MM-YYYY"
                                timeFormat={false}
                                onChange={handlerEndDateTime}
                            //   isValidDate={(currentDate) =>
                            //     selectedfromdate ? currentDate.isSameOrAfter(selectedfromdate, 'day') : true
                            //   }
                            />
                        </div>

                        <div className="mr-2" style={{ minWidth: '200px' }}>
                            <label>Source</label>
                            <Select
                                isMulti={false}
                                id="selected_source"
                                value={
                                    searchfilter.selected_source
                                        ? source_list.find(option => option.value === searchfilter.selected_source)
                                        : { label: "All", value: "All" }
                                }
                                onChange={(selectedOption) =>
                                    handleSelectChange("selected_source", selectedOption)
                                }
                                options={source_list}
                                styles={customSelectStyles}
                            />
                        </div>

                        <div className="mt-auto">
                            <button className="btn btn-success ml-2" onClick={selectfilters}>Search</button>
                        </div>
                        {Object.keys(allindents).length > 0 &&
                            Object.values(allindents).some(arr => Array.isArray(arr) && arr.length > 0) && (
                                <button className="btn btn-warning mr-2 ml-10p" onClick={exportToExcel}>Export To Excel</button>
                            )}

                        {
                            localStorage.getItem('rfq_role') == "SUPER_ADMIN" &&
                            Object.keys(allindents).length > 0 &&
                            Object.values(allindents).some(arr => Array.isArray(arr) && arr.length > 0) &&
                            selectedRows&& selectedRows.length > 0 &&
                             (
                                <button onClick={onclickapprovedata} type="submit" className="btn btn-success">
                                    Approve
                                </button>
                            )}
                    </div>


                    {/* Right Side */}
                    <div className="d-flex align-items-end">

                        <a
                            href="/indentsummary"
                            className="back-btn d-flex align-items-center"
                            style={{ textDecoration: 'none', color: '#101010', fontSize: '14px' }}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-left" viewBox="0 0 16 16">
                                <path fillRule="evenodd" d="M15 8a.5.5 0 0 1-.5.5H3.707l3.147 3.146a.5.5 0 0 1-.708.708l-4-4a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L3.707 7.5H14.5A.5.5 0 0 1 15 8z" />
                            </svg>
                            <span style={{ marginLeft: '5px' }}>Back</span>
                        </a>
                    </div>
                </div>
            </div>
            <div className="col-md-12 col-sm-12">
                <ul className="rfq-tabs d-flex flex-wrap rfq-tab-custom">

                    <li onClick={() => onClickparentTab('pending')}
                        className={"lttabs1 " + rfqform.pending}
                    >
                        <span className="tab-title">Pending</span>
                    </li>
                    <li onClick={() => onClickparentTab('awarded')}
                        className={"lttabs1 " + rfqform.awarded}
                    >
                        <span className="tab-title">Approved </span>
                    </li>
                    <li onClick={() => onClickparentTab('total')}
                        className={"lttabs1 " + rfqform.total}
                    >
                        <span className="tab-title">Total </span>
                    </li>

                </ul>
            </div>



            <div className='card mt-10p'>

                <div className="row ml-35p mr-30p">
                    {checkfortext && (
                        <div className='centered-container1'>
                            <h4>No Indents Found</h4>
                        </div>
                    )}
                    {console.log(allindents, 'allindents')}
                    {Object.keys(allindents).map((source, index) => {
                        const rowData = allindents[source].map((e, idx) => {
                            const rankedVendors = [...e.vendorsquotedata]
                                .filter(v => v.quoted_value)
                                .sort((a, b) => a.quoted_value - b.quoted_value);
                            const top5 = rankedVendors.slice(0, 5);
                            console.log(top5, 'top5')
                            const l10 = rankedVendors.length >= 10 ? rankedVendors[9] : rankedVendors.at(-1);
                            const l1 = rankedVendors[0];

                            // Utility function (declare once outside your loop)
                            function extractDestinationAndMaterial(destinationStr) {
                                let dealerCity = '';
                                let materialTypes = '';

                                try {
                                    const destination = JSON.parse(destinationStr || "[]");
                                    if (Array.isArray(destination) && destination.length > 0) {
                                        // Extract all dealer cities
                                        const dealerCities = destination
                                            .map(dest => dest.dealer_city)
                                            .filter(city => city) // remove null/empty
                                            .join(', ');
                                        dealerCity = dealerCities || '';

                                        // Extract all material types from all destinations
                                        const materials = destination
                                            .flatMap(dest => dest.materials || [])
                                            .map(m => m.material_type)
                                            .filter(m => m) // remove null/empty
                                            .join(', ');
                                        materialTypes = materials || '';
                                    }
                                } catch (err) {
                                    console.error("Error parsing destination:", err);
                                }

                                return { dealerCity, materialTypes };
                            }


                            // Inside your map
                            const { dealerCity, materialTypes } = extractDestinationAndMaterial(e.destination);

                            return {
                                id: idx + 1,
                                indent_id: e.indent_id || '',
                                lr_no: e.lr_no || '',
                                indent_assigned_date: getHyphenYYYYMMDD(e.indent_assigned_date) || '',
                                create_date: getHyphenYYYYMMDD(e.create_date) || '',
                                source: e.source || '',
                                destination: dealerCity,
                                truck_type: (e.type_of_truck === 'others' ? e.selected_truck_type : e.type_of_truck) || '',
                                material: materialTypes,
                                freight_bifurcation: e.freight_bifurcation || '',
                                l1_tat: top5 && top5[0] ? top5[0].transit_time : '',
                                ...Object.fromEntries(top5.map((v, i) => [`L${i + 1}`, `${v.vendor_name} - ₹${v.quoted_value}`])),
                                HighestBid: l10 ? `${l10.vendor_name} - ₹${l10.quoted_value}` : '',
                                TentativeSavings: l10 && l1 ? (l10.quoted_value - l1.quoted_value) : 0,
                                freightdataapproved: e.freightdataapproved || 0,
                                status: e.status
                            };
                        });
                        const email = localStorage.getItem('email');
                        const columnDefs = [
                            ...(localStorage.getItem("rfq_role") == "SUPER_ADMIN"
                                ? [
                                    {
                                        headerName: "",
                                        field: "id",
                                        width: 100,
                                        headerCheckboxSelection: false, // disable header checkbox (no bulk select)
                                        suppressMenu: true,
                                        cellRenderer: function (params) {
                                            var isDisabled = params.data && params.data.freightdataapproved === 1;
                                            var isSelected = params.node.isSelected();

                                            var input = document.createElement('input');
                                            input.type = 'checkbox';
                                            input.disabled = isDisabled;
                                            input.checked = isSelected;

                                            input.addEventListener('change', function (e) {
                                                if (!isDisabled) {
                                                    params.node.setSelected(e.target.checked);
                                                }
                                            });

                                            return input;
                                        }
                                    }
                                ]
                                : []),




                            { headerName: "Indent ID", field: "indent_id", width: 150, },
                            { headerName: "GR No", field: "lr_no", width: 150 },
                            { headerName: "Status", field: "status", width: 180 },
                            {
                                headerName: "Indent Assigned Date", field: "indent_assigned_date", width: 180, valueGetter: function (prams) {
                                    try {
                                        if (prams.data.indent_assigned_date !== "" && prams.data.indent_assigned_date !== undefined) {
                                            return getHyphenDDMMYYYY(prams.data.indent_assigned_date);
                                        }
                                        else {
                                            return "";
                                        }
                                    } catch (error) {

                                    }
                                }
                            },
                            {
                                headerName: "Indent Created Date", field: "create_date", width: 180, valueGetter: function (prams) {
                                    try {
                                        if (prams.data.create_date !== "" && prams.data.create_date !== undefined) {
                                            return getHyphenDDMMYYYY(prams.data.create_date);
                                        }
                                        else {
                                            return "";
                                        }
                                    } catch (error) {

                                    }
                                }
                            },
                            { headerName: "From", field: "source", width: 100 },
                            { headerName: "Destination", field: "destination", width: 190 },
                            { headerName: "Vehicle Type", field: "truck_type", width: 120 },
                            { headerName: "Material", field: "material", width: 100 },
                            { headerName: "Freight Bifurcation (₹)", field: "freight_bifurcation", width: 180 },
                            { headerName: "Highest Bid (₹)", field: "HighestBid" },
                            { headerName: "Tentative Savings (₹)", field: "TentativeSavings" },
                            { headerName: "L1", field: "L1" },
                            { headerName: "L1 TAT", field: "l1_tat" },
                            { headerName: "L2", field: "L2" },
                            { headerName: "L3", field: "L3" },
                            { headerName: "L4", field: "L4" },
                            { headerName: "L5", field: "L5" }

                        ];
                        console.log(allindents, '1186')
                        console.log(rowData, 'rowData')
                        return (

                            <div className="col-xl-12 col-lg-12 mb-5" key={index}>

                                <h5 className="col-sm-6 mt-30p">{source} <span> - Dispatch</span></h5>

                                <div className="ag-theme-balham" style={{
                                    height: Math.max(250, Math.min(500, 50 + rowData.length * 40)), // 50 is header, 30 per row
                                    width: '100%',
                                    transition: 'height 0.3s ease'
                                }}>
                                    <AgGridReact
                                        rowData={rowData}
                                        columnDefs={columnDefs}
                                        defaultColDef={defaultColDef}
                                        enableRangeSelection={true}
                                        enableCharts={true}
                                        rowSelection="multiple"
                                        statusBar={{
                                            statusPanels: [
                                                {
                                                    statusPanel: "agTotalAndFilteredRowCountComponent",
                                                    align: "left",
                                                },
                                                {
                                                    statusPanel: "agTotalRowCountComponent",
                                                    align: "center",
                                                },
                                                { statusPanel: "agFilteredRowCountComponent" },
                                                { statusPanel: "agSelectedRowCountComponent" },
                                                { statusPanel: "agAggregationComponent" },
                                            ],
                                        }} stopEditingWhenGridLosesFocus={true}
                                        pagination={true}
                                        paginationPageSize={50}
                                        isRowSelectable={(rowNode) => {
                                            // Disable selection if freightdataapproved === 1
                                            return rowNode.data && rowNode.data.freightdataapproved !== 1;
                                        }}
                                        getRowClass={(params) => {
                                            // Add a custom class to visually gray out rows with disabled checkbox
                                            return params.data.freightdataapproved === 1 ? 'disabled-row' : '';
                                        }}
                                        suppressRowClickSelection={true}
                                        headerHeight={50}
                                        onSelectionChanged={(e) => {
                                            const selected = e.api.getSelectedRows();
                                            setSelectedRows(selected); // Optional: set your selected state
                                        }}
                                    />
                                </div>
                            </div>
                        );
                    })}

                </div>
            </div>

            <div className={"dataLoadpage " + (loadshow)}>
            </div>
            <div className={"dataLoadpageimg " + (loadshow)}>
                <div class="loader-box"><div class="loader-box"><div class="rotate dashed colored"></div></div></div>
            </div>
            <div className={"overlay " + (overlay)} onClick={onClickHideall}></div>
        </div >
    );
};

export default Freightrateapprovalsummarycomponent;

function giveUTCDate(date) {
    return moment.parseZone(new Date(date)).utcOffset("-05:30")._d
}
const generateUniqueId = () => {
    return 'icon-' + Math.random().toString(36).substr(2, 9); // Generate a simple unique ID
};